import React, { useEffect } from 'react'

interface SEOProps {
  title: string
  description?: string
  canonicalPath?: string
}

const SEO: React.FC<SEOProps> = ({ title, description, canonicalPath }) => {
  useEffect(() => {
    // Update Title
    document.title = title

    // Update Meta Description
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription && description) {
      metaDescription.setAttribute('content', description)
    }

    // Update Canonical URL
    const linkCanonical = document.querySelector('link[rel="canonical"]')
    if (linkCanonical) {
      const href = `https://jobloads.com${canonicalPath || window.location.pathname}`
      linkCanonical.setAttribute('href', href)
    }

    // Update OG Title
    const ogTitle = document.querySelector('meta[property="og:title"]')
    if (ogTitle) {
      ogTitle.setAttribute('content', title)
    }

    // Update OG Description
    const ogDescription = document.querySelector('meta[property="og:description"]')
    if (ogDescription && description) {
      ogDescription.setAttribute('content', description)
    }
  }, [title, description, canonicalPath])

  return null
}

export default SEO
